export default "__VITE_ASSET__CiK0_hRF__"